import enData from "../../resume/en-data.yaml";
import esData from "../../resume/es-data.yaml";

export const languages = [
  {

    name: "Español",
    code: "es",
    data: esData,
    resumeLabels: {
      contacts: "Contacto",
      profile: "Perfil",
      skills: "Competencias técnicas",
      experience: "Experiencia",
      professional: "Desarrollo de software",
      professional_2: "Ciencia de datos e Inteligencia artificial",
      professional_3: "Sistemas mecatrónicos",
      professional_4: "Competencias Blandas",
      research: "Investigación",
      education : "Educación formal",
      

    },
  },
 
  {

    name: "English",
    code: "en",
    data: enData,
    resumeLabels: {
      contacts: "Contacts",
      profile: "Profile",
      skills: "Technical skills",
      experience: "Experience",
      professional: "Software development",
      professional_2: "Data science and artificial intelligence",
      professional_3: "Mechatronic systems",
      professional_4: "Soft Skills",
      research: "Research",
      education: "Formal education",
      
    }
  },
];

export function getCurrentLanguage() {
  return languages[0];
}

export function getLanguages() {
  return languages;
}
